import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import getStudenti from "../../services/getStudenti";

import getEsami from "../../services/getEsami";
import setValutazione from "../../services/setValutazione";
import getValutazioni from "../../services/getValutazioni";
import EditEsame from "../../widgets/EditEsame";
import editEsame from "../../services/editEsame";

export default class EsameDetails extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];
    this.studenti = [];

    this.grid = 2;

    this.pageTitle = "EsameDetails";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
      details: [],
      insertEsameShow: false,
      editShow: false,
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });
    const currentEsame = cookies.get("currentEsame", { path: "/" });

    this.corsoId = currentCourse;
    this.esami = await getEsami(username, token, currentCourse);
    this.esame = this.esami.find((e) => e.id == currentEsame);
    this.esameName = this.esame.nome;

    this.studenti = await getStudenti(username, token, true); // include_disabled per coerenza con EditCorso
    const cc = String(currentCourse);
    this.studenti = this.studenti.filter((s) => {
      if (!s.corsi) return false;
      // Gestisce diversi formati: singolo ID, separati da virgola o punto e virgola
      const corsiList = s.corsi
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      const ritiroList = (s.corsi_ritiro || "")
        .split(/[,;]/)
        .map((id) => id.trim())
        .filter((id) => id);
      return corsiList.includes(cc) && !ritiroList.includes(cc);
    });
    this.studenti.sort((a, b) =>
      a.cognome < b.cognome || (a.cognome == b.cognome && a.nome < b.nome)
        ? -1
        : 1,
    );

    this.valutazioni = await getValutazioni(username, token, this.esame.id);
    this.studenti.forEach((s) => {
      var voto = this.valutazioni.find((v) => v.id_studente == s.id);
      s.valutazione = voto != undefined ? voto.valutazione : -1;
      s.recuperato = voto != undefined && voto.recuperato == 1 ? true : false;
      // Salva i valori originali per confronto al salvataggio
      s._valutazioneOriginale = s.valutazione;
      s._recuperatoOriginale = s.recuperato;
    });

    this.setState({});
  }

  render() {
    if (this.esame == undefined) return <div />;
    return (
      <div>
        <PageTitle
          title={this.esameName + " del " + this.esame.data}
          button="Modifica"
          onClick={() => this.setState({ editShow: true })}
        />
        <FixButton title="Salva" callback={this.save.bind(this)} />

        <table>
          {this.studenti.map((s, index) => {
            return (
              <tr key={s.id}>
                <td>{s.cognome + " " + s.nome} </td>
                <td>
                  <TextInput
                    width="50px"
                    value={
                      this.studenti[index].valutazione != -1
                        ? this.studenti[index].valutazione
                        : "NC"
                    }
                    onChange={(text) => {
                      //                  this.studenti[index].valutazione = text != '' ? text : -1;
                      this.studenti[index].valutazione = text;
                      this.setState({});
                    }}
                  />{" "}
                </td>
                <td>
                  <input
                    type="checkbox"
                    id={`recuperato_${s.id}`}
                    checked={this.studenti[index].recuperato || false}
                    onChange={(e) => {
                      this.studenti[index].recuperato = e.target.checked;
                      this.setState({});
                    }}
                  />
                  <label
                    htmlFor={`recuperato_${s.id}`}
                    style={{ marginLeft: "5px" }}
                  >
                    Recuperato
                  </label>
                </td>
              </tr>
            );
          })}
        </table>
        <EditEsame
          key={Math.random()}
          show={this.state.editShow}
          titolo={this.esameName}
          data={this.esame.data}
          onOkClicked={async (data, titolo) => {
            const cookies = new Cookies();
            const username = cookies.get("username", { path: "/" });
            const token = cookies.get("token", { path: "/" });
            const currentCourse = cookies.get("currentCourse", { path: "/" });
            const currentEsame = cookies.get("currentEsame", { path: "/" });

            await editEsame(username, token, currentEsame, data, titolo);

            this.esami = await getEsami(username, token, currentCourse);
            this.esame = this.esami.find((e) => e.id == currentEsame);
            this.esameName = this.esame.nome;

            this.setState({ editShow: false });
          }}
          onCancel={() => {
            this.setState({ editShow: false });
          }}
        />
      </div>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const userId = cookies.get("userId", { path: "/" });
    const nomeEsame = this.esameName;

    for (var i = 0; i < this.studenti.length; i++) {
      var studente = this.studenti[i];
      var valutazione = parseInt(studente.valutazione);
      if (
        studente.valutazione != "NC" &&
        (isNaN(valutazione) || valutazione > 110 || valutazione < -1)
      ) {
        alert("Errore, controlla i valori inseriti");
        return;
      }
    }

    let salvati = 0;
    for (var i = 0; i < this.studenti.length; i++) {
      var studente = this.studenti[i];
      const valCorrente =
        studente.valutazione == "NC" ? -1 : studente.valutazione;
      const recCorrente = studente.recuperato ? 1 : 0;
      const valOriginale = studente._valutazioneOriginale;
      const recOriginale = studente._recuperatoOriginale ? 1 : 0;

      // Salva solo se il voto o il flag recuperato sono cambiati
      if (valCorrente != valOriginale || recCorrente != recOriginale) {
        await setValutazione(
          username,
          token,
          this.corsoId,
          this.esame.id,
          studente.id,
          valCorrente,
          userId,
          nomeEsame,
          recCorrente,
        );
        // Aggiorna i valori originali dopo il salvataggio
        studente._valutazioneOriginale = valCorrente;
        studente._recuperatoOriginale = studente.recuperato;
        salvati++;
      }
    }

    alert(
      salvati > 0
        ? `Salvataggio completato (${salvati} voti aggiornati)`
        : "Nessuna modifica da salvare",
    );
    window.location.href = "/#/app/EditCorso";
  }
}
